import { Link, LoaderFunction, redirect } from "react-router-dom";
import { pathname } from "#src/config/pathname";
import { authService } from "#src/services/auth";

export const authenticatePageLoader: LoaderFunction = async ({ request }) => {
  const url = new URL(request.url);

  const returnUrl = url.searchParams.get("return_url") ?? pathname.HOME;
  const token = url.searchParams.get("token");

  if (token) {
    // Check if token is valid. If it's valid, save user info. If not, code inside error handler will redirect us.
    authService.updateAccessToken(token);

    // Throw user to corresponded URL, and pray that id.cs put them to right place.
    if (returnUrl === "/login") return redirect(pathname.HOME);
    return redirect(returnUrl);
  } else {
    // If there's no token, redirect to Login.
    return redirect(pathname.LOGIN);
  }
};

/** Login process use an ID page, which will return here with a token. With that token and return_url, this page will redirect to accorded products. */
export const AuthenticatePage = () => {
  return (
    <>
      You should have been redirected else where! Bad dev D:
      <br />
      Click <Link to={pathname.HOME}>here</Link> to go back.
    </>
  );
};
